KMVP.regionalassortment = {
    bindBindingsOnPopoverShown: function () {
        $('.js-session-address-popup').on('shown.bs.popover', function () {
            KMVP.regionalassortment.bindZipCodeChangePost($('#' + $(this).attr('aria-describedby')));
        })
    },

    bindZipCodeChangePost: function ($container) {
        var $submitZipcodeChange = $container.find('.js-submit-zipcode-change'),
            $submitZipcodeInput = $container.find('.js-global-zipcode-input');

        $submitZipcodeChange.on('click', function (e) {
            $.ajax({
                async: false,
                type: "POST",
                dataType: $container.hasClass('js-support') ? 'html' : 'json',
                contentType: 'application/json',
                url: $(this).attr('data-url'),
                data: JSON.stringify({
                    zipCode: $submitZipcodeInput.val()
                }),
                success: function (data, status) {
                    window.location.reload();
                },
                error: function (jqXHR, exception) {
                    console.log(exception);
                }
            });
        });

        // submit on enter key
        $submitZipcodeInput.on('keydown', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $submitZipcodeChange.click();
            }
        });

        //set focus for the zipcode input and mark it
        $submitZipcodeInput.focus();
        $submitZipcodeInput.select();

        KMVP.registration.initLoginRegisterButtonHandler();
    }
    ,
    bindSessionAddressChange: function () {
        $('.js-session-address-change').on('click', function(e) {
            KMVP.regionalassortment.handleSessionAddressChangeClick(this, $(this).data('show-address-selection'), $(this).data('show-company-selection'));
        });
    },
    handleSessionAddressChangeClick: function (sessionAddressChangeElement, showAddressSection, showCompanySection) {
        var openColorBox = function () {
            $.colorbox({
                inline: true,
                href: "#summaryDeliveryAddressOverlay",
                innerWidth: "890px",
                onLoad: function () {
                    $('#cboxClose').remove();
                },
                onComplete: function () {
                    ACC.common.refreshScreenReaderBuffer();
                    ACC.checkoutB2B.validateDeliveryAddressPopUp();
                    $.colorbox.resize();
                },
                onCleanup: function () {
                    KMVP.regionalassortment.addressChangeCleanup()
                },
                onClosed: function () {
                    ACC.common.refreshScreenReaderBuffer();
                }
            });
        };

        $("#summaryDeliveryAddressBook").hide();
        var changeFormUrl = $(sessionAddressChangeElement).closest(".js-summaryDeliveryAddress").data('get-form') + "?createUpdateStatus=1&addressId=" + $(sessionAddressChangeElement).data("address") + "&showAddressSection=" + showAddressSection + "&showCompanySection=" + showCompanySection;

        var getUrl = $(sessionAddressChangeElement).closest(".js-summaryDeliveryAddress").data('get');

        ACC.checkoutB2B.showAddressForm(changeFormUrl, getUrl, openColorBox, false);
    },
    bindOnChangeSwitchToggle: function () {
        $("#show-only-in-stock").change(function () {
            var showOnlyOnStock = $(this).is(':checked'),
                $switchOn = $('.switch-on'),
                forceEnterZipCode = $('.js-force-enter-zipcode').data('value');
            if (showOnlyOnStock) {
                $switchOn.addClass('font-weight-bold');

                if (forceEnterZipCode == true) {
                    KMVP.regionalassortment.forceEntryOfPostalCode();
                }
            } else {
                $switchOn.removeClass('font-weight-bold');
            }

            // Execute only on pdp
            if ($(".page-productDetails").length !== 0) {
                callVariantResource(ACC.productDetail.getAllDimensionCodes());
            }

            // Execute only on searchlistpage
            if ($(".template-pages-search-searchListPage, .template-pages-category-productListPage").length !== 0 && forceEnterZipCode == false) {
            	var paramInput = $('#js-show-only-on-stock-code');
                if (showOnlyOnStock) {
            		paramInput.val("on");
            	}
            	else {
            		paramInput.val("off");
            	}
                var form = $('.js-showInStockSearchForm');
                var actionUrl = form.attr('action');
            	$.ajax({
			        type: "POST",
			        url: actionUrl,
			        data: form.serialize(), // serializes the form's elements.
			        success: function (data, status) {
			        	if (location.href.toString().includes('#')) {
			        		history.pushState("", document.title, window.location.pathname + window.location.search);
			        	}
                    	$('.js-showInStockSearchHiddenForm').submit();
	                },
	                error: function (jqXHR, exception) {
	                    console.log("cannot submit showOnlyStock flag value change", exception);
	                }
			    });
            }
        });
    },

    forceEntryOfPostalCode: function () {
        $(".js-session-address-popup").trigger('mouseenter');
        $(".js-session-address-popup").off("mouseleave");
        $(".js-session-address-popup").off("mouseout");

        $('#cboxOverlay').show();
    },

    /**
     * Triggers the validation of the cart entries against the given address ONLY if it's valid
     */
    notbuyableProductsSection: function (addressPopupForceToHandle) {
        let $notBuyableProducts = $(".js-notbuyable-products-section");
        var url = $notBuyableProducts.data('validate-entries');
        if(addressPopupForceToHandle){
            url = url + "?addressPopupForceToHandle=true";
        }
        $.get(url, function (data) {
                    $notBuyableProducts.html(data);
                    $.colorbox.resize();
                    KMVP.masterCarts.bindMoveCartEntryToQuoteRequest();
            }
        );
    },

    handleCloseButton: function () {
        $('.js-button-edit-deliveryaddress-cancel').on("click", function (e) {
            e.preventDefault();
            $('.js-button-edit-deliveryaddress-cancel').attr('data-isclicked', 'true');
            var $initialAddressId = $('input[name=initialAddressId]').val();
            var url = $('#summaryDeliveryAddressFormWrapper').data('reset-address') + "?addressId=" + $initialAddressId;
            $.get(url, function(data){
                // for now empty
            })
            $.colorbox.close();
        });
    },

    bindSubmitButton: function () {
        $('.js-button-edit-deliveryaddress-save').on("click", function (e) {
            $('input[name=isUseAddressClicked]').val('true');
        });

    },

    addressChangeCleanup: function () {
        var isAddressChanged = $('input[name=isAddressChanged]').val() === 'true'
        var isUseAddressClicked = $('input[name=isUseAddressClicked]').val() === 'true'
        var cancelClicked = $('.js-button-edit-deliveryaddress-cancel').attr('data-isclicked');
        if ( !isAddressChanged && !isUseAddressClicked && !cancelClicked ) {
            $('.js-button-edit-deliveryaddress-cancel').trigger( "click" );
        }
    },

    initialize: function () {
        KMVP.regionalassortment.bindBindingsOnPopoverShown();
        KMVP.regionalassortment.bindSessionAddressChange();
        KMVP.regionalassortment.bindOnChangeSwitchToggle();

        if (ACC.address.showSessionAddressChangeOverlay == true) {
            KMVP.regionalassortment.handleSessionAddressChangeClick($('.js-session-address-change')[0], false, true);
        }
    }
};

$(document).ready(function () {
    KMVP.regionalassortment.initialize();
});